import { defineComponent as _defineComponent } from 'vue'
import { Customer } from '@/models/tenant';
import {
  RestrictedCustomer,
  customersService,
} from '@/services/tenants.service';
import { ValidationRules } from '@/utils/validation';
import { isNil } from '@/utils/misc';
import useVuelidate from '@vuelidate/core';
import { computed, onBeforeMount, ref } from 'vue';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'CustomersSelect',
  props: {
    value: null,
    validationRules: { default: () => ({}) },
    disabled: { type: Boolean, default: false },
    showLabel: { type: Boolean, default: false },
    restricted: { type: Boolean, default: false }
  },
  emits: ["input:name", "input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input:name', name: string): void;
  (e: 'input', id: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: number, validationRules: ValidationRules, disabled: boolean, showLabel: boolean, restricted: boolean };





const { t } = useI18n();

const customers = ref<Array<Customer | RestrictedCustomer>>([]);
const isLoading = ref(false);

const selectedCustomer = computed<number>({
  get() {
    return props.value;
  },
  set(newValue) {
    const customer = getCustomerById(newValue)!;
    emit('input:name', customer.name);
    emit('input', newValue);
  },
});
const validations = {
  customerId: props.validationRules,
};
const v$ = useVuelidate(validations, {
  customerId: selectedCustomer,
});

onBeforeMount(() => {
  fetchCustomers();
});

async function fetchCustomers() {
  isLoading.value = true;
  try {
    if (props.restricted) {
      customers.value = await customersService.getRestricted();
    } else {
      customers.value = await customersService.get();
    }
    if (!isNil(props.value) && props.value > 0) {
      emit('input:name', getCustomerById(props.value)!.name);
    }
  } finally {
    isLoading.value = false;
  }
}

function getCustomerById(id: number) {
  return customers.value.find((x) => x.id === id);
}

function getErrorMessage() {
  return v$.value.customerId.$errors?.[0]?.$message;
}

const isRequired = computed(() => 'required' in props.validationRules);

return { __sfc: true,props, emit, t, customers, isLoading, selectedCustomer, validations, v$, fetchCustomers, getCustomerById, getErrorMessage, isRequired }
}

})